// @ts-nocheck
export default new Proxy(
  {},
  {
    get: (obj, prop) => obj[prop],
    set: (obj, prop, value) => {
      obj[prop] = value;
      return true;
    },
  },
);
